import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './ReconciliationReportsTableHead.scss';

export const RECONCILIATION_REPORTS_TABLE_HEADER = [
  {
    label: 'reportDate',
    sortBy: 'reportDate'
  },
  {
    label: 'transferProvider',
    sortBy: 'transferProvider'
  },
  {
    label: 'currency',
    sortBy: 'currency'
  },
  {
    label: 'closingTransitAccountBalance'
  },
  {
    label: 'closingCommissionAccountBalance'
  },
  {
    label: 'closingCustomerAccountsTotal'
  },
  {
    label: 'incomingTransactionsTotal'
  },
  {
    label: 'incomingExchangesTotal'
  },
  {
    label: 'outgoingTransactionsTotal'
  },
  {
    label: 'outgoingExchangesTotal'
  },
  {
    label: 'commissionsTotal'
  }
];

const ReconciliationReportsTableHead = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {RECONCILIATION_REPORTS_TABLE_HEADER.map(
        (head) =>
          head.label && (
            <th key={head.label} className={'reconciliation-reports-table-head'}>
              <div className={'reconciliation-reports-table-head-block'}>
                <span>{i18n.getMessage(`reconciliationReports.table.header.${head.label}`)}</span>
                {head.sortBy && (
                  <ArrowSelect
                    onClick={() => handleOnSortTable(head.sortBy)}
                    className={`reconciliation-reports-sorting-arrow-icon ${sortBy === head.sortBy && direction}`}
                  />
                )}
              </div>
            </th>
          )
      )}
    </tr>
  );
};

ReconciliationReportsTableHead.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};

export default ReconciliationReportsTableHead;
